import React, { useState } from 'react'
import { Breadcrumbs, DropDownMenu, DynamicEntityIndex, GlobalLoader } from '@reactiveonline/reactive_admin_shared-packages'
import CreateTenantModal from '../shared/CreateTenantModal'
import ImportAccountsModal from '../shared/ImportAccountsModal'
import GlobalImports from '../shared/GlobalImports'
import { truncateText } from '../../helpers/utils'

export default function Index({
  appProps, admin, canImportAccounts, createRegistrationsPath, countriesPath, getAvailableFlavoursAndPackagesPath, getOrganizationsPath, getRegistrationDataPath, registrationsPath, importAccountsPath,
  breadcrumbs, entityPath, exportRegistrationsPath, filters, icon, initialTotalPages, listColumns, selectedColumns, registrations, totalCount
}) {
  const [showCreateTenantModal, setShowCreateTenantModal] = useState(false)
  const [showImportModal, setShowImportModal] = useState(false)
  const [availableOrganizationData, setAvailableOrganizationData] = useState([])
  const [countries, setCountries] = useState([])
  const [loading, setLoading] = useState(false)

  const dropdownActions = [
    {
      icon: 'fa-plus',
      action: () => handleCreateTenantClick(),
      text: Partners.translations.create_tenant,
      permissions: true
    },
    {
      icon: 'fa-upload',
      action: () => setShowImportModal(true),
      text: Partners.translations.tenant.import_from_excel,
      permissions: canImportAccounts
    }
  ]

  const closeCreateTenantModal = () => {
    setShowCreateTenantModal(false)
  }

  const handleCreateTenantClick = () => {
    if (availableOrganizationData.length === 0) {
      setLoading(true)

      getCountries()

      Rails.ajax({
        type: 'GET',
        url: `${ getRegistrationDataPath }?admin_id=${ admin.id }`,
        dataType: 'json',
        success: res => {
          setAvailableOrganizationData(res.items)
          setLoading(false)
          setShowCreateTenantModal(true)
        }
      })
    } else {
      setShowCreateTenantModal(true)
    }
  }

  const getCountries = () => {
    Rails.ajax({
      type: 'GET',
      url: countriesPath,
      dataType: 'json',
      success: res => setCountries(res.availableCountries)
    })
  }

  const itemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => {
          if (['createdAt', 'storeName'].includes(column.label) && item[column.label]) {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ `${ entityPath }/${ item.apiUid }` }>
                  { column.label === 'storeName' ? truncateText(item[column.label]) : item[column.label] }
                </a>

                { item.archived && column.label === 'storeName' &&
                  <div className='tooltip-button'>
                    <i className='fa-light fa-circle-exclamation' style={{ color: 'red' }}/>
                    <div className='tooltip'>
                      { Partners.translations.tenant.deleted_account }
                    </div>
                  </div>
                }
              </div>
            )
          } else {
            return (
              <div key={ column.label } className='item flex-1'>
                { item[column.label] || '-' }

                { item.archived && column.label === 'storeName' &&
                  <div className='tooltip-button'>
                    <i className='fa-light fa-circle-exclamation' style={{ color: 'red' }}/>
                    <div className='tooltip'>
                      { Partners.translations.tenant.deleted_account }
                    </div>
                  </div>
                }
              </div>
            )
          }
        })}
      </>
    )
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%'}}>
          <div className='flex-box items-center content-space-between flex-wrap' style={{ gap: 20 }}>
            <div className='page-header'>
              <i className={ `fa-light ${ icon }` }/>
              <h1 className='page-header-title'>
                { Partners.translations.registration.plural }
                <span className='m-l-10'>({ totalCount })</span>
              </h1>
            </div>
              <DropDownMenu
                items={ dropdownActions }
                title={ ReactiveCore.translations.dropMenuAction }
              />
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <DynamicEntityIndex
        initialItems={ registrations }
        initialTotalPages={ initialTotalPages }
        disableDelete={ true }
        entity={ 'registrations' }
        filters={ filters }
        tabs={ [] }
        tableHeadings={ selectedColumns }
        disableCustomization={ true }
        itemRenderer={ itemRenderer }
        itemsPath={ entityPath }
        icon={ icon }
        noResourcesTitle={ Partners.translations.registration.no_registrations }
        listColumns={ listColumns }
        columnTranslations={ Partners.translations.columns }
        isExportable
        selectAll={ true }
        exportPath={ exportRegistrationsPath }
      />

      { showCreateTenantModal &&
        <CreateTenantModal
          admin={ admin }
          availableOrganizationData={ availableOrganizationData }
          closeModal={ closeCreateTenantModal }
          createRegistrationsPath={ createRegistrationsPath }
          countries={ countries }
          getAvailableFlavoursAndPackagesPath={ getAvailableFlavoursAndPackagesPath }
        />
      }

      { showImportModal &&
        <ImportAccountsModal
          adminRole={ admin.role }
          closeModal={ () => setShowImportModal(false) }
          getOrganizationsPath={ getOrganizationsPath }
          registrationsPath={ registrationsPath }
          loading={ loading }
          setLoading={ setLoading }
          importAccountsPath={ importAccountsPath }
        />
      }

      { loading && <GlobalLoader fullPage /> }
      <GlobalImports appProps={ appProps } />
    </>
  )
}
